import ElementUI from 'element-ui'
import Vue from 'vue'

function returnSuccess(val,returnType) {
    let msg = returnType +'成功'
    if (val == "success") {
        ElementUI.Message({
            message: msg,
            type: "success",
        });
    }
}
function returnRrror(val,returnType){
    if (val == "error") {
        ElementUI.Message({
            message: returnType,
            type: "error",
        });
    }
}
export default{
    returnSuccess,
    returnRrror
}